import React, { useState } from 'react';
import { IconColumn, IconFilter } from '../../../../../common/icons/index';
import CustomSelect from '../../../../../common/CustomSelect';
import FilterPop from './filterPop';

const options = [
  { value: 'Cameron Williamson', label: 'Cameron Williamson ' },
  { value: 'John Doe', label: 'John Doe' },
  { value: 'Alex Mendes', label: 'Alex Mendes' },
];

const SearchFilter = () => {
  //Filter
  const [ShowFilter, setShowFilter] = useState(false);
  const handleShowFilter = (event) => {
    setShowFilter(true);
  };
  const handleHideFilter = (event) => {
    setShowFilter(false);
  };
  const [isPopDrop, setIsPopDrop] = useState(false);
  const handlePopDrop = (event) => {
    setIsPopDrop(!isPopDrop);
  };
  return (
    <React.Fragment>
      <div className="filter-row d-flex align-items-center mb-10">
        {/* Search Bar */}
        <div className="app-search header-search mr-20">
          <span className="search-icon"> </span>
          <div className="position-relative">
            <input
              type="search"
              className="form-control input-search-left"
              placeholder="Search..."
              value=""
              style={{ width: '150px' }}
            />
          </div>
        </div>
        {/* Select Customer */}
        <CustomSelect
          name={'name'}
          options={options}
          value={1}
          isMulti={true}
          isClearable={true}
          size="small"
          placement="right"
          placeholder="All Shipping"
          className="w-150 mr-2"
        />
        <CustomSelect
          name={'name'}
          options={options}
          value={1}
          isMulti={true}
          isClearable={true}
          size="small"
          placement="right"
          placeholder="Search"
          className="w-150 mr-2"
        />
        <CustomSelect
          name={'name'}
          value={1}
          isMulti=""
          isClearable={true}
          size="small"
          placement="right"
          placeholder="All Terminals"
          className="w-150"
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
        />

        {/* Filter Settings */}
        <div className="ml-auto d-flex">
          <button className="btn btn-outline-light" onClick={handleShowFilter}>
            <IconFilter className="mr-2" />
            Filter
          </button>
        </div>
      </div>
      {/* Filter Popup */}
      {ShowFilter && <FilterPop hideFilter={handleHideFilter} />}
    </React.Fragment>
  );
};

export default SearchFilter;
